/**
 *
 * GridContainer
 *
 */
import React from 'react';
import classnames from 'classnames';

var GridContainer = function GridContainer(_ref) {
  var variation = _ref.variation,
      extraClasses = _ref.extraClasses,
      children = _ref.children;
  return React.createElement("div", {
    className: classnames('grid-container', variation, extraClasses)
  }, children);
};

GridContainer.defaultProps = {
  variation: 'fluid'
};
GridContainer.displayName = 'GridContainer';
export default GridContainer;